export default {
  // Header
  "title": "Генератор случайных Покемонов",
  "subtitle": "Создавайте случайных покемонов по вашим предпочтениям",
  "home": "Главная",
  "whichPokemonAmI": "Какой я покемон?",
  "aboutUs": "О нас",
  "contactUs": "Контакты",
  "privacyPolicy": "Политика конфиденциальности",
  
  // Filters
  "filterTitle": "Параметры фильтра",
  "generateButton": "Создать случайного покемона",
  "generating": "Создание...",
  "numberOfPokemon": "Количество покемонов",
  "type": "Тип",
  "generation": "Поколение",
  "minimumRarity": "Минимальная редкость (1-10)",
  "anyType": "Любой тип",
  "anyGeneration": "Любое поколение",
  "anyRarity": "Любая редкость",
  "countingPokemon": "Подсчет подходящих покемонов",
  "matchingPokemonCount": "{{count}} покемонов соответствуют вашим фильтрам",
  
  // Pokemon Types
  "normal": "Нормальный",
  "fire": "Огненный",
  "water": "Водный",
  "electric": "Электрический",
  "grass": "Травяной",
  "ice": "Ледяной",
  "fighting": "Боевой",
  "poison": "Ядовитый",
  "ground": "Земляной",
  "flying": "Летающий",
  "psychic": "Психический",
  "bug": "Насекомое",
  "rock": "Каменный",
  "ghost": "Призрак",
  "dragon": "Дракон",
  "dark": "Темный",
  "steel": "Стальной",
  "fairy": "Волшебный",
  
  // Generations
  "Generation I": "Поколение I",
  "Generation II": "Поколение II",
  "Generation III": "Поколение III",
  "Generation IV": "Поколение IV",
  "Generation V": "Поколение V",
  "Generation VI": "Поколение VI",
  "Generation VII": "Поколение VII",
  "Generation VIII": "Поколение VIII",
  "Generation IX": "Поколение IX",
  
  // Evolution Stage
  "evolutionStage": "Стадия Эволюции",
  "evolutionStageAll": "Все Стадии",
  "evolutionStageFullyEvolved": "Полностью Эволюционировавший",
  "evolutionStageNotFullyEvolved": "Не Эволюционировавший Полностью",
  
  // About Section
  "aboutTitle": "О Генераторе случайных Покемонов",
  
  // Section titles
  "introTitle": "Добро пожаловать в Генератор случайных Покемонов",
  "howToUseTitle": "Как использовать Генератор случайных Покемонов",
  "benefitsTitle": "Преимущества использования Генератора случайных Покемонов",
  "historyTitle": "История Покемонов",
  "popularPokemonTitle": "Популярные покемоны",
  "popularGamesTitle": "Популярные игры о покемонах",
  "tradingContestsTitle": "Обмен покемонами и соревнования",
  "faqTitle": "Часто задаваемые вопросы",
  "conclusionTitle": "Начните свое случайное приключение с покемонами уже сегодня!",
  
  // Footer
  "copyright": "© 2025 randompokemon.games",
  "trademark": "Покемон и имена персонажей Покемон являются торговыми марками Nintendo.",
  "linksTitle": "Полезные ссылки",
  
  // About Us Page
  "aboutUsTitle": "О нас",
  "aboutUsWhoWeAre": "Кто мы",
  "aboutUsWhoWeAreContent1": "Добро пожаловать в Генератор случайных Покемонов, инструмент, созданный фанатами для энтузиастов Покемонов. Наше путешествие началось в 2023 году, когда группа разработчиков, любящих как программирование, так и Покемонов, решила создать полезный инструмент для сообщества.",
  "aboutUsWhoWeAreContent2": "Наша команда состоит из разработчиков, дизайнеров и создателей контента, которые работают вместе, чтобы предоставить наилучший опыт фанатам Покемонов по всему миру.",
  "aboutUsOurMission": "Наша миссия",
  "aboutUsOurMissionContent1": "Мы стремимся сделать мир Покемонов более доступным и увлекательным для всех. Наши инструменты разработаны, чтобы помочь тренерам открывать новых покемонов, создавать сбалансированные команды и находить идеальных покемонов.",
  "aboutUsOurMissionContent2": "Мы стремимся предоставить удобный, точный и веселый опыт, который уважает франшизу Покемон, добавляя ценность сообществу.",
  "aboutUsOurTeam": "Наша команда",
  "aboutUsOurTeamContent1": "Наша разнообразная команда объединяет опыт в веб-разработке, знания о Покемонах, дизайн пользовательского опыта и управление сообществом. Нас объединяет любовь к Покемонам и приверженность созданию высококачественных инструментов.",
  "aboutUsOurTeamContent2": "Каждый член команды вносит свои уникальные навыки и перспективы, чтобы сделать Генератор случайных Покемонов как можно лучше.",
  "aboutUsJoinUs": "Присоединяйтесь к нам",
  "aboutUsJoinUsContent": "Мы всегда ищем увлеченных людей для присоединения к нашему сообществу. Будь вы разработчиком, дизайнером, экспертом по Покемонам или просто энтузиастом, ваши отзывы и вклад приветствуются.",
  
  // Contact Us Page
  "contactUsTitle": "Контакты",
  "contactUsGetInTouch": "Свяжитесь с нами",
  "contactUsGetInTouchContent": "У вас есть вопросы, предложения или отзывы о Генераторе случайных Покемонов? Мы хотели бы услышать от вас! Вот как вы можете связаться с нашей командой.",
  "contactUsEmail": "Электронная почта",
  "contactUsPhone": "Телефон",
  "contactUsAddress": "Адрес",
  "contactUsHelpSupport": "Помощь и поддержка",
  "contactUsHelpSupportContent": "Нужна помощь в использовании наших инструментов или столкнулись с проблемой? Наша команда поддержки здесь, чтобы помочь.",
  "contactUsFAQ": "Часто задаваемые вопросы",
  "contactUsFAQContent": "Прежде чем связаться с нами, пожалуйста, проверьте наш раздел FAQ, который охватывает многие общие вопросы и проблемы.",
  "contactUsBugReport": "Отчет об ошибке",
  "contactUsBugReportContent": "Если вы нашли ошибку или техническую проблему, пожалуйста, сообщите нам, отправив электронное письмо с темой 'Отчет об ошибке'.",
  
  // Privacy Policy Page
  "privacyPolicyTitle": "Политика конфиденциальности",
  "privacyPolicyIntro": "Введение",
  "privacyPolicyIntroContent": "В Генераторе случайных Покемонов мы уважаем вашу конфиденциальность и привержены защите ваших личных данных. Эта Политика конфиденциальности объясняет, как ваша информация собирается, используется и защищается, когда вы используете наш веб-сайт.",
  "privacyPolicyInformation": "Информация, которую мы собираем",
  "privacyPolicyInformationContent": "Мы собираем минимальную информацию для предоставления и улучшения наших услуг. Это может включать:",
  "privacyPolicyInformationItem1": "Данные использования (такие как просмотренные страницы, время, проведенное на сайте, используемые функции)",
  "privacyPolicyInformationItem2": "Информация об устройстве (тип браузера, операционная система, разрешение экрана)",
  "privacyPolicyInformationItem3": "IP-адрес и приблизительное местоположение (только на уровне страны)",
  "privacyPolicyCookies": "Файлы cookie и похожие технологии",
  "privacyPolicyCookiesContent": "Мы используем файлы cookie для улучшения вашего опыта на нашем сайте. Эти небольшие текстовые файлы позволяют нам запоминать ваши предпочтения и анализировать использование нашего сайта. Вы можете контролировать файлы cookie через настройки вашего браузера.",
  "privacyPolicyThirdParty": "Сторонние сервисы",
  "privacyPolicyThirdPartyContent": "Наш веб-сайт может использовать сторонние сервисы, такие как провайдеры аналитики и сети доставки контента. Эти сервисы могут собирать информацию о вашем использовании нашего веб-сайта. Мы обеспечиваем, чтобы все третьи стороны уважали вашу конфиденциальность и обрабатывали данные соответствующим образом.",
  "privacyPolicySecurity": "Безопасность данных",
  "privacyPolicySecurityContent": "Мы реализуем соответствующие меры безопасности для защиты вашей информации от несанкционированного доступа, изменения, раскрытия или уничтожения. Однако, ни одна передача через Интернет не является 100% безопасной, поэтому мы не можем гарантировать абсолютную безопасность.",
  "privacyPolicyChanges": "Изменения в этой политике",
  "privacyPolicyChangesContent": "Мы можем время от времени обновлять нашу Политику конфиденциальности. Мы будем уведомлять вас о любых изменениях, публикуя новую Политику конфиденциальности на этой странице и обновляя дату 'Последнее обновление'.",
  "privacyPolicyContact": "Свяжитесь с нами",
  "privacyPolicyContactContent": "Если у вас есть какие-либо вопросы об этой Политике конфиденциальности, пожалуйста, свяжитесь с нами через информацию, предоставленную на странице Контакты.",
  "privacyPolicyLastUpdated": "Последнее обновление",
  
  // Which Pokemon Am I Page
  "whichPokemonAmITitle": "Какой я покемон?",
  "whichPokemonAmISubtitle": "Узнайте, какой покемон вам подходит лучше всего",
  "enterYourName": "Введите ваше имя",
  "namePlaceholder": "Ваше имя",
  "enterFavoriteColor": "Выберите ваш любимый цвет",
  "enterBirthMonth": "Выберите месяц вашего рождения",
  "selectBirthMonth": "Выберите месяц",
  "enterPersonalityTrait": "Выберите черту вашего характера",
  "selectPersonalityTrait": "Выберите черту",
  "findMyPokemon": "Найти моего покемона",
  "calculating": "Вычисление...",
  "yourPokemonIs": "Ваш покемон",
  "pokemonDescription": "Описание",
  "personalityMatch": "Соответствие характера",
  "yourCompatibility": "Ваша совместимость",
  "downloadImage": "Скачать изображение",
  "shareResult": "Поделиться результатом",
  "tryAgain": "Попробовать снова",
  "results": "Результаты",
  "aboutTool": "Об этом инструменте",
  "howToUse": "Как использовать",
  "benefits": "Преимущества",
  "faq": "Часто задаваемые вопросы",
  "conclusion": "Заключение",
  
  // Error messages
  "nameRequired": "Имя обязательно",
  "colorRequired": "Пожалуйста, выберите цвет",
  "monthRequired": "Пожалуйста, выберите месяц",
  "traitRequired": "Пожалуйста, выберите черту характера",
  
  // Months
  "january": "Январь",
  "february": "Февраль",
  "march": "Март",
  "april": "Апрель",
  "may": "Май",
  "june": "Июнь",
  "july": "Июль",
  "august": "Август",
  "september": "Сентябрь",
  "october": "Октябрь",
  "november": "Ноябрь",
  "december": "Декабрь",
  
  // Personality Traits
  "brave": "Храбрый",
  "calm": "Спокойный",
  "timid": "Робкий",
  "jolly": "Веселый",
  "quiet": "Тихий",
  "hasty": "Торопливый",
  "careful": "Осторожный",
  "lonely": "Одинокий",
  "bold": "Смелый",
  "relaxed": "Расслабленный",
  "impish": "Озорной",
  "modest": "Скромный",
  
  // Additional translations for size matching feature
  "heightValid": "Пожалуйста, введите действительный рост (1-300 см)",
  "weightValid": "Пожалуйста, введите действительный вес (1-500 кг)",
  "enterDetails": "Введите ваши данные",
  "nameLabel": "Имя",
  "heightLabel": "Рост",
  "weightLabel": "Вес",
  "finding": "Поиск...",
  "errorFinding": "Ошибка при поиске вашего покемона",
  "matchResult": "Покемон {{name}} это...",
  "similarityScore": "Оценка сходства",
  "downloadStarted": "Подготовка изображения...",
  "downloadComplete": "Изображение успешно скачано!",
  "shareText": "Я обнаружил, что я {{pokemon}}! Узнайте, какой покемон вы!",
  
  // Size matching feature
  "enterHeightWeight": "Введите ваш рост и вес — узнайте, какой Покемон вам соответствует!",
  "whichPokemonMatchesSize": "Какой Покемон соответствует вашему размеру?",
  "youAreMostLike": "Вы больше всего похожи на",

  // New Page: Pokemon Randomizer - About Section Titles (Translated to Russian)
  "pokemonRandomizerPageAboutTitle": "Откройте для себя непревзойденный опыт Рандомайзера Покемонов",
  "pokemonRandomizer_whatIsItTitle": "Что именно такое Рандомайзер Покемонов?",
  "pokemonRandomizer_featuresTitle": "Ключевые особенности нашего инструмента Рандомайзер Покемонов",
  "pokemonRandomizer_whyUseTitle": "Зачем отправляться в приключение с Рандомайзером Покемонов?",
  "pokemonRandomizer_gettingStartedTitle": "Начало работы: ваш первый запуск Рандомайзера Покемонов",
  "pokemonRandomizer_faqTitle": "Рандомайзер Покемонов: Часто задаваемые вопросы",

  // New keys for PokemonRandomizerPage.tsx H1 and subtitle (Translated to Russian)
  "pokemonRandomizerPageH1": "Рандомайзер Покемонов",
  "pokemonRandomizerPageSubtitle": "Создавайте уникальные впечатления от Покемонов с помощью нашего продвинутого инструмента рандомизации.",

  // Sub-Footer
  subFooterToolsTitle: "Инструменты",
  subFooterRandomPokemonGeneratorLink: "Генератор случайных Покемонов",
  subFooterPokemonRandomizerLink: "Рандомайзер Покемонов",
  subFooterWhichPokemonAmILink: "Какой я покемон?",

  subFooterPokemonDatabaseTitle: "База данных Покемонов",
  subFooterPokedexLink: "Покедекс (Скоро)",
  subFooterTypeChartsLink: "Таблицы типов (Скоро)",
  subFooterMoveListLink: "Список атак (Скоро)",

  subFooterBlogTitle: "Блог",
  subFooterLatestArticlesLink: "Последние статьи (Скоро)",
  subFooterGuidesTutorialsLink: "Руководства и туториалы (Скоро)"
};
